/**
 * 实际承运人档案列表 - 常量与字典
 * 与后端 dict / 筛选条件取值保持一致
 */

// 统计默认值
export const DEFAULT_STATS = {
  totalDrivers: 0,
  todayNew: 0,
  complianceCount: 0,
  complianceRate: 0,
  expireSoon30: 0,
  expired: 0
};

// 审核状态
export const AUTH_STATUS_OPTIONS = [
  { value: 0, label: "未审核" },
  { value: 1, label: "审核中" },
  { value: 2, label: "审核未通过" },
  { value: 3, label: "审核通过" }
];

// 实际承运人状态（优先级：注销 > 拉黑 > 冻结 > 未提交 > 正常）
export const DRIVER_STATUS_OPTIONS = [
  { value: "normal", label: "正常" },
  { value: "unsubmitted", label: "未提交" },
  { value: "cancel", label: "已注销" },
  { value: "black", label: "已拉黑" },
  { value: "freeze", label: "已冻结" }
];

// 车辆经营性质
export const VEHICLE_NATURE_OPTIONS = [
  { value: 1, label: "自有车" },
  { value: 2, label: "挂靠车" },
  { value: 3, label: "租赁车" },
  { value: 4, label: "承包车" }
];

// 客服确认状态（is_confirmed：0未确认/1已确认）
export const CONFIRM_STATUS_OPTIONS = [
  { value: 0, label: "未确认" },
  { value: 1, label: "已确认" }
];

// 税务上报状态
export const TAX_REPORT_STATUS_OPTIONS = [
  { value: 0, label: "待上报" },
  { value: 1, label: "已上报" },
  { value: 2, label: "退回" }
];

// 交通入库状态
export const TRAFFIC_REPORT_STATUS_OPTIONS = [
  { value: 0, label: "待入库" },
  { value: 1, label: "已入库" },
  { value: 2, label: "异常" }
];

// 财务绑定状态
export const BANK_BIND_STATUS_OPTIONS = [
  { value: "bank", label: "银行卡已绑" },
  { value: "aliPay", label: "支付宝已绑" },
  { value: "none", label: "均未绑定" }
];

// 黑名单类型
export const BLACK_TYPE_OPTIONS = [
  { value: "资质造假", label: "资质造假" },
  { value: "严重违约", label: "严重违约" },
  { value: "安全红线", label: "安全红线" },
  { value: "恶意行为", label: "恶意行为" },
  { value: "司法失信", label: "司法失信" },
  { value: "监管通报", label: "监管通报" },
  { value: "严重投诉", label: "严重投诉" }
];

// 证件类型（列表“证件效期”列使用）
export const CERT_TYPES = [
  { key: "certId", label: "身份证" },
  { key: "certLicense", label: "驾驶证" },
  { key: "certWork", label: "从业资格证" }
];
